import graphql__732fd3a50b53f3334619 from "./__generated__/AnswerPreviewString_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const AnswerPreviewString = props => {
  return props.answer.content || "-";
};

export default createFragmentContainer(AnswerPreviewString, {
  answer: graphql__732fd3a50b53f3334619
});
